// extracted by mini-css-extract-plugin
module.exports = {"select-task-dialog":"select-task-dialog-08331f5730f28972203871cd1b9654f2"};